import React, { useContext, useEffect } from "react";
import PedidosContext from "../../Context/Pedidos/PedidosContext";
import { Grid } from "@mui/material";
import CardPedido from "../../components/Cards/pedidos/CardPedido";
import NoDataComponent from "../../components/loading/NoDataComponents";
const PedidosCancelados = () => {
  const { orders_client, GetPedidosCancelados } = useContext(PedidosContext);
  useEffect(() => {
    GetPedidosCancelados();
  }, []);
  return (
    <Grid container spacing={2}>
      {orders_client.length > 0 ? (
        <>
          {orders_client.map((order, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={index}>
              <CardPedido order={order} />
            </Grid>
          ))}
        </>
      ) : (
        <NoDataComponent />
      )}
    </Grid>
  );
};

export default PedidosCancelados;
